import { initialState, type TapState } from "./tap";

export const SAVE_VERSION = 1;

/** What gets persisted. Timing fields are session-only and start fresh. */
export interface SaveData {
  version: number;
  coins: number;
}

export function toSave(state: TapState): SaveData {
  return { version: SAVE_VERSION, coins: state.coins };
}

/** Restores state from untrusted stored data; anything unexpected starts a fresh game. */
export function fromSave(data: unknown): TapState {
  if (typeof data !== "object" || data === null) return initialState();
  const { version, coins } = data as Partial<SaveData>;
  if (version !== SAVE_VERSION) return initialState();
  if (typeof coins !== "number" || !Number.isSafeInteger(coins) || coins < 0) return initialState();
  return initialState(coins);
}
